import { useMutation } from '@apollo/client';
import { IconButton } from '@saucelabs/ds-button';
import { IconMoreFill } from '@saucelabs/ds-icons';
import { Menu, MenuItem } from '@saucelabs/ds-menu';
import React from 'react';
import { Tooltip } from '@saucelabs/ds-tooltip';

import { graphql } from '../../graphql/__generated__';

type Props = {
  buildId: string;
  onCompleted?: () => void;
  noBaseline: number;
  total: number;
}

const ApproveBuildMutation = graphql(`
  mutation ApproveBuildMutation ($input: ApproveBuildIn!) {
    approveBuild(input: $input) {
      ...BuildsViewBuildFragment
    }
  }
`);

const BuildsItemMenu: React.FC<Props> = ({ buildId, onCompleted, total, noBaseline }) => {
  const [approveBuildRequest, { loading }] = useMutation(ApproveBuildMutation, {
    onCompleted,
  });

  const approveBuild = async () => {
    await approveBuildRequest({
      variables: { input: { id: null, uuid: buildId, onlyNew: false } },
    });
  };

  const approveNoBaselineBuild = async () => {
    await approveBuildRequest({
      variables: { input: { id: null, uuid: buildId, onlyNew: true } },
    });
  };

  return (
    <Menu
      triggerElement={({ triggerProps, targetRef }) => (
        <Tooltip
          ref={targetRef}
          placement="top"
          title="Actions"
        >
          <IconButton
            icon={<IconMoreFill className="w-2 h-2" />}
            size="sm"
            variant="text"
            {...triggerProps}
            disabled={loading}
            onClick={(event) => {
              event.preventDefault();
            }}
          />
        </Tooltip>
      )}
    >
      <MenuItem
        isDisabled={!total}
        onAction={approveBuild}
      >
        Accept All (
        {total}
        )
      </MenuItem>
      <MenuItem
        isDisabled={!noBaseline}
        onAction={approveNoBaselineBuild}
      >
        Accept Only New (
        {noBaseline}
        )
      </MenuItem>
    </Menu>
  );
};

export default BuildsItemMenu;
